<template lang="pug">
  b-modal#editPaymentOptionProvider(
  ref="editPaymentOptionProvider"
  :title="$t('ui.combine.edit_payment_option_provider')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  size="lg"
  ok-only
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success")
      b-form-group.mb-3
        div.row.mb-3.animated.fadeIn
          div.col
            table.tablex(style="width: 100%;")
              thead
                tr
                  th
                    span {{ $t('ui.group') }}
                  th.text-center
                    span {{ $t('ui.status') }}
                  th.text-center
                    span {{ $t('ui.recommend') }}
                  th.text-center
                    span {{ $t('ui.sequence') }}
                  th.text-center
                    span {{ $t('ui.min_limit') }}
                  th.text-center
                    span {{ $t('ui.max_limit') }}
                  th.text-center
                    span &nbsp;
              tbody
                tr(v-for="(item, index) in list")
                  td
                    span.font-weight-bold.text-uppercase {{ item.provider_group }}
                  //- td.text-center
                  //-   span
                  //-     i(:class="{'fas fa-check text-info': item.status, 'fas fa-times text-warning': !item.status  }")
                  td.text-center
                    div.d-flex.justify-content-center.align-items-center
                      label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                        input.switch-input(type="checkbox" v-model="item.status" @change="changedProviderStatus(item, $event)")
                        span.switch-slider(:data-checked='on' :data-unchecked='off')
                  td.text-center
                    div.d-flex.justify-content-center.align-items-center
                      label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                        input.switch-input(type="checkbox" v-model="item.is_recommend" @change="changedProviderRecommend(item, $event)")
                        span.switch-slider(:data-checked='on' :data-unchecked='off')
                  td.text-center
                    select(
                      :value="item.seq"
                      size="md"
                      @change="changedProviderSeq(item, $event)"
                      )
                      option(value=0 disabled) 0
                      option(v-for="index in list.length" :key="index") {{ index }}
                  td.text-center
                    input(
                      style="width:100% !important;"
                      type="text"
                      size="sm"
                      v-model="item.min_limit"
                    )
                  td.text-center
                    input(
                      style="width:100% !important;"
                      type="text"
                      size="sm"
                      v-model="item.max_limit"
                    )
                  td.text-center
                    SubmitButton(
                      :loading="loading"
                      icon="fa fa-check"
                      :text="$t('ui.update')"
                      type="button"
                      @click="changedProviderLimit(item)"
                      variant="info"
                      size="sm"
                      )
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      list: [],
      payment_mode: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      editField : ''
    };
  },
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
  },
  methods: {
    changedProviderSeq: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_provider_group_seq_confirm", { mode: this.payment_mode, group: item.provider_group }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmProviderSeq(item, eventStatus.srcElement.value);
          } else {
            // console.log(item)
            eventStatus.srcElement.value = item.seq;
          }
        });
    },
    confirmProviderSeq: function(item, seq) {
      let url = config.paymentOptionProviderUpdateSeqUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        payment_mode: this.payment_mode,
        provider_group: item.provider_group,
        seq: seq,
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getProviderList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                //this.$emit("failed", "edit_payment_option_provider", this.feedback.status);
                // this.$refs.editPaymentOptionProvider.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedProviderRecommend: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_provider_group_recommend_confirm", { mode: this.payment_mode, group: item.provider_group }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmProviderRecommend(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.is_recommend;
            item.is_recommend = !item.is_recommend;
          }
        });
    },
    confirmProviderRecommend: function(item, status) {
      let url = config.paymentOptionProviderUpdateRecommendUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        payment_mode: this.payment_mode,
        provider_group: item.provider_group,
        new_status: status,
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getProviderList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                //this.$emit("failed", "edit_payment_option_provider", this.feedback.status);
                // this.$refs.editPaymentOptionProvider.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedProviderStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_provider_group_status_confirm", { mode: this.payment_mode, group: item.provider_group }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmProviderStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmProviderStatus: function(item, status) {
      let url = config.paymentOptionProviderUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        payment_mode: this.payment_mode,
        provider_group: item.provider_group,
        new_status: status,
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getProviderList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                //this.$emit("failed", "edit_payment_option_provider", this.feedback.status);
                // this.$refs.editPaymentOptionProvider.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedProviderLimit: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_provider_group_limit_confirm", { mode: this.payment_mode, group: item.provider_group }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmProviderLimit(item);
          } else {
            this.getProviderList();
          }
        });
    },
    confirmProviderLimit: function(item) {
      let url = config.paymentOptionProviderUpdateLimitUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        payment_mode: this.payment_mode,
        provider_group: item.provider_group,
        min_limit: item.min_limit,
        max_limit: item.max_limit,
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getProviderList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                //this.$emit("failed", "edit_payment_option_provider", this.feedback.status);
                // this.$refs.editPaymentOptionProvider.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getProviderList() {
      let url = config.paymentOptionProviderListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        payment_mode: this.payment_mode
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.list = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.payment_mode = this.item.payment_mode;
      this.list = [];
      this.getProviderList();
    }
  }
};
</script>
